import "./home.scss";

(function () {
  document.body.classList.add("rapport-annuel");

  const el = document.querySelector(".skills");

  const tl = gsap.timeline({
    scrollTrigger: {
      pin: document.querySelectorAll(".skills .facts"),
      scrub: 1,
      trigger: el,
      start: "top center",
      end: "bottom 60%",
      invalidateOnRefresh: true,
    },
    defaults: { ease: "none", duration: 0.4 },
  });
  tl.to(".skill", { x: () => -(el.scrollWidth - el.clientWidth) }, 0);
})();
